export const CurrencyConfig = Object.freeze({
  en: {
    symbol: null,
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: true
  },
  eu: {
    symbol: null,
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  }
})

export const CurrencyConfigEN = CurrencyConfig.en
export const CurrencyConfigEU = CurrencyConfig.eu
